'use client';

import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '24px',
        background: 'var(--bg-1)',
        color: 'var(--color-body)',
        fontFamily: 'var(--font-body)',
      }}
    >
      {/* Logo */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '32px' }}>
        <img src="/logo192.png" alt="WebIP" style={{ height: '28px', width: '28px', objectFit: 'contain' }} />
        <span style={{ fontSize: '1.1rem', fontWeight: 700, letterSpacing: '0.02em' }}>
          Web<span style={{ color: '#7ed321' }}>IP</span>
        </span>
      </div>

      <div
        style={{
          fontSize: 'clamp(4rem, 12vw, 8rem)',
          fontWeight: 800,
          lineHeight: 1,
          color: 'var(--tc-color-primary, #0b2e5e)',
          fontFamily: 'var(--font-display)',
        }}
      >
        404
      </div>

      <h1
        style={{
          fontSize: 'var(--fs-h2)',
          fontWeight: 700,
          margin: '16px 0 8px',
          color: 'var(--color-heading)',
        }}
      >
        Página não encontrada
      </h1>

      <p style={{ fontSize: 'var(--fs-body)', color: 'var(--color-muted)', maxWidth: '440px', marginBottom: '32px' }}>
        O endereço que você tentou acessar não existe ou foi movido. Verifique a URL ou volte para a página inicial.
      </p>

      <Link
        to="/appliances"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          padding: '10px 20px',
          borderRadius: '8px',
          backgroundColor: 'var(--tc-color-primary, #0b2e5e)',
          color: 'white',
          fontWeight: 600,
          textDecoration: 'none',
          transition: 'opacity var(--dur-base, 0.2s) var(--ease-standard, ease)',
        }}
      >
        Voltar para o início
      </Link>
    </div>
  );
};

export default NotFoundPage;
